

export const TopPromotionalBanner = (promotionBanners) => {

    const promotionBanner = promotionBanners?.promotionBanners
    return (
        <div>{(promotionBanner[0]?.image_url) &&
            <div className="se-w-full se-h-fit" style={{ textAlign: 'center', marginBottom: 5, width: '100%' }}>
                <a href={"https://homerun.page.link/tzH3"} target="_blank" rel="noreferrer">
                    <img className="se-h-auto se-w-full se-hidden md:se-block" src={'/images/homerunBanner2.png'} alt="upper-banner" height="100px" width="100%" />
                    <img className="se-h-auto se-w-full md:se-hidden" src={'/images/mobileBanner.png'} alt="upper-banner" height="100px" width="100%" />
                </a>
            </div>
        }
        </div>
    )
}

export const BottomPromotionalBanner = (promotionBanner) => {
    return (
        <div>
            {(promotionBanner?.length > 1) && <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
                {promotionBanner?.map((banner_obj, index) => {
                    return (
                        (index !== 0 && banner_obj?.image_url) &&
                        (<div style={{ width: `${100 / (promotionBanner?.length - 1)}%` }}>
                            <a key={index} href={banner_obj?.redirect} target="_blank" rel="noreferrer">
                                <img src={banner_obj?.image_url} alt={banner_obj?.title} width={'100%'} />
                            </a>
                        </div>)
                    )
                })}
            </div>}
        </div>
    )
}

